import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-error-dialog",
  templateUrl: "./error-dialog.component.html",
  styleUrls: ["./error-dialog.component.scss"],
})
export class ErrorDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public errorMsg: string,
    public errorDialogRef: MatDialogRef<ErrorDialogComponent>
  ) {}

  ngOnInit() {
    this.errorDialogRef.addPanelClass("error-dialog");
  }
}
